import request from '@/config/axios'

export const getCreditPage = (params: any) => request.get({ url: '/rental/credit/page', params })
export const auditCredit = (data: { id: number; pass: boolean; remark?: string }) =>
  request.put({ url: '/rental/credit/audit', data })
